import { createStore } from "botframework-webchat";
import { WEB_VIEW_EXT_ID } from "./Extensions/WebViewExtension/WebViewExtension";
import { WEB_VIEW_EX_EXT_ID } from "./Extensions/WebViewExternalExtension/WebViewExternalExtension";
import { CHAT_SUGGESTION_EXT_ID } from "./Extensions/ChatSuggestionExtension/ChatSuggestionExtension";
import { CHAT_AUTOCOMPLETE_EXT_ID } from "./Extensions/AutoCompleteExtension/AutoCompleteExtension";
import { un } from "zendesk-chat-sdk";
const BMB_LOG_URL = process.env.REACT_APP_API_URL + "/saveMessage";
const BMB_ROOMTYPE_URL = process.env.REACT_APP_API_URL + "/properties";
const BMB_Property_URL = process.env.REACT_APP_API_URL + "/property";
const BMB_Conversation_URL = process.env.REACT_APP_API_URL + "/conversation";
const BMB_AutoComplete_URL = process.env.REACT_APP_API_URL + "/chatsuggestions";
/**
 * Activity from Microsoft Directline
 */
function incomingActivity(dispatch, next, action, callbacks) {
  callbacks.enableChat(); // Enables the input box, effective when the first message from the bot arrives
  callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, undefined);
  callbacks.scrollChat();
  var dl = callbacks.getChatState().directline;
  if (
    isRecentActivity(action) &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.channelData
  ) {
    // Suggestion UI
    //console.log(action.payload.activity);
    if (action.payload.activity.channelData.suggestionUi) {
      action.payload.activity.suggestedActions = []; // hide dafault suggestion style
      let suggestionsPayload = action.payload.activity.channelData.suggestionUi;
      suggestionsPayload.time = Date.now();
      suggestionsPayload.question = action.payload.activity.text;
      callbacks.setExtension(CHAT_SUGGESTION_EXT_ID, suggestionsPayload);
    } else if (action.payload.activity.channelData.liveChat) {
      if (
        action.payload.activity.channelData.liveChat.provider === "bmbLiveChat"
      ) {
        const liveChatSetings = callbacks.getLiveChatSettings();
        if (liveChatSetings !== undefined && liveChatSetings.provider == "0") {
          const noAgentOnline = setTimeout(() => {
            clearTimeout(noAgentOnline);
            AgentCheck(
              "RequestSent",
              callbacks,
              "no_agent_online",
              dispatch
            ).then((m) => {
              if (m) {
                const AgentOnline = setTimeout(() => {
                  clearTimeout(AgentOnline);
                  AgentCheck(
                    "RequestReceived",
                    callbacks,
                    "agent_online_not_accepted",
                    dispatch
                  ).then((n) => {
                    if (!n) {
                      const AgentOnlineNext = setTimeout(() => {
                        clearTimeout(AgentOnlineNext);
                        AgentCheck(
                          "RequestReceived",
                          callbacks,
                          "agent_online_busy",
                          dispatch
                        );
                      }, 60 * 1000);
                    }
                  });
                }, 20 * 1000);
              }
            });
          }, 10 * 1000);
        }
      } else {
        if (
          action.payload.activity.channelData.liveChat.provider === "zendesk"
        ) {
          callbacks.startZenDeskChat();
        } else if (
          action.payload.activity.channelData.liveChat.provider ===
          "genesys_cloud"
        ) {
          callbacks.startGenesysPureCloudChat();
        } else if (
          action.payload.activity.channelData.liveChat.provider === "mews"
        ) {
          callbacks.startMewsChat(
            action.payload.activity.channelData.liveChat?.threadData
          );
        } else if (
          action.payload.activity.channelData.liveChat.provider ===
          "aws_connect"
        ) {
          callbacks.startAWSConnectChat();
        }
      }
    } else if (action.payload.activity.channelData.setContext) {
      if (
        action.payload.activity.channelData.setContext.name ===
        "SetPropertyIdUI"
      ) {
        callbacks.ChangePropertyId(
          action.payload.activity.channelData.setContext.value
        );
      }
    }
    // Web View
    if (action.payload.activity.channelData.webView) {
      let webviewPayload = action.payload.activity.channelData.webView;
      if (webviewPayload.title === "Open Login") {
        window.parent.postMessage(`openWindowUrl:${webviewPayload.url}`, "*");
      }
      if (webviewPayload.title === "Open Register") {
        window.parent.postMessage(`openUrl:${webviewPayload.url}`, "*");
      } else if (webviewPayload.title === "Close Login") {
        window.parent.postMessage(`closeWindowUrl:${webviewPayload.url}`, "*");
      } else if (webviewPayload.title === "Booking Url") {
        if (window.parent) {
          window.parent.postMessage(`openUrl:${webviewPayload.url}`, "*");
        } else {
          window.location = webviewPayload.url;
        }
      } else if (webviewPayload.title === "Availability") {
        callbacks.setAvailblity(webviewPayload.availabilityData);
      } else if (webviewPayload.title === "LocationPopUp") {
        callbacks.setPropertyPopUp(true);
      } else if (webviewPayload.title === "New Lang Detect") {
        callbacks.ChangeBotLanguage(webviewPayload.url, true);
      } else {
        if (
          webviewPayload.title !== "Open Register" &&
          webviewPayload.title !== "Open Login"
        ) {
          if (
            webviewPayload.token !== undefined &&
            webviewPayload.token !== null &&
            webviewPayload.token !== ""
          ) {
            const tokenInterval = setInterval(() => {
              if (
                document.getElementById("webviewframe") !== undefined &&
                document.getElementById("webviewframe") !== null
              ) {
                document
                  .getElementById("webviewframe")
                  .contentWindow.postMessage(
                    `tokenUpdateWebview:${webviewPayload.token}`,
                    "*"
                  );
                clearInterval(tokenInterval);
              }
            }, 2000);
          }

          if (webviewPayload.largeWindow) {
            callbacks.setExtension(WEB_VIEW_EX_EXT_ID, webviewPayload);
          } else {
            callbacks.setExtension(WEB_VIEW_EXT_ID, webviewPayload);
          }
        }
      }
    }
  }

  if (
    isRecentActivity(action) &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.suggestedActions
  ) {
    if (action.payload.activity.inputHint === "Recommender") {
      callbacks.hideTypingTextBox();
    }
  } else if (
    isRecentActivity(action) &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type &&
    action.payload.activity.type === "message" &&
    action.payload.activity.from.role === "bot" &&
    action.payload.activity.attachments !== undefined &&
    action.payload.activity.attachments.length > 0 &&
    action.payload.activity.attachments[0].contentType ===
      "application/vnd.microsoft.card.signin"
  ) {
    callbacks.hideTypingTextBox();
  } else if (
    isRecentActivity(action) &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type &&
    action.payload.activity.type === "message" &&
    action.payload.activity.from.role === "bot"
  ) {
    callbacks.showTypingTextBox();
  }

  if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text.startsWith("Transferring you to a human")
  ) {
    if (!callbacks.getChatState().livechat) {
      callbacks.startLivechat();
    }
  } else if (
    //isRecentActivity(action) &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type &&
    action.payload.activity.type === "event" &&
    action.payload.activity.text === "Nova"
  ) {
    console.log("Nova event received");
    if (window.parent) {
      window.parent.postMessage("NovaToken:" + dl.conversationId, "*");
    }
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text === dl.conversationId &&
    action.payload.activity.name === undefined
  ) {
    if (!callbacks.getChatState().twiliochat) {
      callbacks.startTwiliochat(
        dl.conversationId,
        action.payload.activity.from.id
      );
    }
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text === dl.conversationId &&
    action.payload.activity.name &&
    action.payload.activity.name === "signalRConversation"
  ) {
    if (!callbacks.getChatState().signalrchat) {
      callbacks.startSignalRchat(
        dl.conversationId,
        action.payload.activity.from.id
      );
    }
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text.startsWith("Agent") &&
    action.payload.activity.text.indexOf("has joined") > 0
  ) {
    callbacks.setAgentId(action.payload.activity.from.id);
    // console.log("175");
    bmbLogMessageWihMessageId(
      action.payload.activity.text,
      "Visitor",
      callbacks,
      action.payload.activity.id
    );
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text.startsWith("Agent") &&
    action.payload.activity.text.indexOf("left the conversation") > 0
  ) {
    if (callbacks.isInTwiliochat() === true) {
      callbacks.endTwilio();
    } else if (callbacks.isInSignalRchat() === true) {
      callbacks.endSignalRChat();
    }
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text.startsWith("Ok, I’ll show you our rooms12")
  ) {
    var propertyId = callbacks.getPID();
    if (propertyId === undefined || propertyId === "") {
      var property = localStorage.getItem(
        callbacks.getChatState().lStore.PROPERTYID
      );
      if (property !== undefined && property != null) {
        propertyId = property;
      }
    }

    fetch(BMB_ROOMTYPE_URL + "/" + propertyId + "/rooms", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        callbacks.getRoomTypes(json.rooms);
        callbacks.showBookingForm(false, false);
      });
  } else if (callbacks.getChatState().getRoomTypes) {
    if (
      action.payload &&
      action.payload.activity &&
      action.payload.activity.text &&
      action.payload.activity.text.startsWith("I can answer your questions")
    ) {
      var propertyId = callbacks.getPID();
      if (propertyId === undefined || propertyId === "") {
        var property = localStorage.getItem(
          callbacks.getChatState().lStore.PROPERTYID
        );
        if (property !== undefined && property != null) {
          propertyId = property;
        }
      }
      fetch(BMB_ROOMTYPE_URL + "/" + propertyId + "/rooms", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((json) => callbacks.getRoomTypes(json.rooms));
    } else if (
      action.payload &&
      action.payload.activity &&
      action.payload.activity.text &&
      action.payload.activity.text.startsWith(
        "Ok, Please fill the information to check availability"
      )
    ) {
      var propertyId = callbacks.getPID();
      if (propertyId === undefined || propertyId === "") {
        var property = localStorage.getItem(
          callbacks.getChatState().lStore.PROPERTYID
        );
        if (property !== undefined && property != null) {
          propertyId = property;
        }
      }

      fetch(
        BMB_Property_URL +
          "/" +
          propertyId +
          "?groupId=" +
          callbacks.getGID() +
          "",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          if (
            json.property.ari.applicable === "Y" &&
            json.property.ari.type === "URL"
          ) {
            //Show Room Details
            fetch(BMB_ROOMTYPE_URL + "/" + propertyId + "/rooms", {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((response) => response.json())
              .then((roomdata) => callbacks.getRoomTypes(roomdata.rooms));
          } else if (
            json.property.ari.applicable === "Y" &&
            json.property.ari.type === "CHATUI"
          ) {
            //Show Availablity Popup
            callbacks.showBookingForm(true, true);
            callbacks.getRoomTypes([]);
          }
        });
    }
  } else if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.text &&
    action.payload.activity.text.startsWith(
      "Ok, Please fill the information to check availability"
    )
  ) {
    var propertyId = callbacks.getPID();
    if (propertyId === undefined || propertyId === "") {
      var property = localStorage.getItem(
        callbacks.getChatState().lStore.PROPERTYID
      );
      if (property !== undefined && property != null) {
        propertyId = property;
      }
    }

    fetch(
      BMB_Property_URL +
        "/" +
        propertyId +
        "?groupId=" +
        callbacks.getGID() +
        "",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (
          json.property.ari.applicable === "Y" &&
          json.property.ari.type === "URL"
        ) {
          //Show Room Details
          fetch(BMB_ROOMTYPE_URL + "/" + propertyId + "/rooms", {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((roomdata) => callbacks.getRoomTypes(roomdata.rooms));
        } else if (
          json.property.ari.applicable === "Y" &&
          json.property.ari.type === "CHATUI"
        ) {
          //Show Availablity Popup
          callbacks.showBookingForm(true, true);
          callbacks.getRoomTypes([]);
        }
      });
  }

  if (
    action.payload &&
    action.payload.activity &&
    action.payload.activity.attachments
  ) {
    filterAttachments(dispatch, action.payload.activity, callbacks);
  }

  if (
    isRecentActivity(action) &&
    callbacks.isInGenesysPureCloudChat() === true
  ) {
    if (
      action.payload &&
      action.payload.activity &&
      action.payload.activity.text
    ) {
      var msg = action.payload.activity.text;
      // console.log("378");
      bmbLogMessageWihMessageId(
        msg,
        "Agent",
        callbacks,
        action.payload.activity.id
      );
    }
  }

  if (isRecentActivity(action) && callbacks.isInMewsChat() === true) {
    if (
      action.payload &&
      action.payload.activity &&
      action.payload.activity.text
    ) {
      var msg = action.payload.activity.text;
      // console.log("391");
      bmbLogMessageWihMessageId(
        msg,
        "Agent",
        callbacks,
        action.payload.activity.id
      );
    }
  }

  return next(action);
}

function isRecentActivity(action) {
  if (
    !(
      action.payload &&
      action.payload.activity &&
      action.payload.activity.timestamp
    )
  ) {
    return false;
  }

  let time = new Date(action.payload.activity.timestamp);
  return Date.now() - time.valueOf() < 6000;
}

/**
 * Manages custom handling of attachments for new activities
 */
function filterAttachments(dispatch, activity, callbacks) {
  if (Date.now() - Date.parse(activity.timestamp) > 10000) {
    return; // Assume anything sent >10s ago is stale (e.g. reloaded when app opened)
  }
  //ffaaa
  for (var i = 0; i < activity.attachments.length; i++) {
    let attachment = activity.attachments[i];
    let remove = false;
    switch (attachment.contentType) {
      case "ako.bob.payment":
        attachment.content.handled = true;
        remove = true;
        callbacks.makePayment(attachment.content, () => {
          dispatch({
            type: "WEB_CHAT/SEND_MESSAGE",
            payload: {
              name: "ako/sentpayment",
              text: "Test",
            },
          });
        });
        break;
      default:
        break;
    }

    if (remove) {
      activity.attachments.splice(i, 1);
      i--;
    }
  }
}

/**
 * Activity going back channel Events, normally to Microsoft Directline but this method may not redirect for WebView
 */
function outgoingBackChannelEvents(dispatch, next, action, callbacks) {
  //console.log("action.payload.name", action.payload.name);
  if (action.payload.name === "webchat/openWebView") {
    var payload = {
      url: action.payload.value.url,
      title: action.payload.value.title,
      mode: action.payload.value.mode,
      largeWindowHideHeader: action.payload.value.largeWindowHideHeader,
    };
    payload.largeWindow = true;
    callbacks.setExtension(WEB_VIEW_EX_EXT_ID, payload);
    return;
  }
  if (action.payload.name === "webchat/booking") {
    var dl = callbacks.getChatState().directline;
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.value.msg,
      timestamp: new Date().toISOString(),
      type: "message",
    };
    // console.log("477");
    bmbLogMessageBot(
      "Booking",
      action.payload.value.msg,
      "Visitor",
      callbacks,
      activityId
    );

    //return next({ payload: { activity }, type: "DIRECT_LINE/INCOMING_ACTIVITY" });
    return;
  } else {
    return next(action);
  }
}

// Some activities should be modified when they are reloaded from storage
// (this gives them different behaviour than when sent in the first place)
function processStoredActivities(stored) {
  for (let activity of stored.activities) {
    if (activity.attachments) {
      for (let attachment of activity.attachments) {
        if (attachment.contentType === "ako/file-upload-prompt") {
          attachment.content.used = true;
        }
      }
    }
  }
}

function setSuggestedActions(dispatch, next, action, callbacks) {
  if (
    !action.payload.suggestedActions ||
    action.payload.suggestedActions.length < 1
  ) {
    return next(action);
  }

  setTimeout(() => next(action), 500);
}

function AgentCheck(status, callbacks, eventName, dispatch) {
  var gid = callbacks.getGID();
  var conversationId = callbacks.getDirectLineConversation();
  return fetch(
    BMB_Conversation_URL + "/" + conversationId + "?groupId=" + gid + "",
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((json) => {
      // console.log(604, json);
      if (json !== undefined) {
        if (
          json.conversation.agentStatus === status ||
          json.conversation.agentStatus === "None"
        ) {
          dispatchAgentOnlineEvents(dispatch, eventName);
          return false;
        } else {
          return true;
        }
      } else {
        dispatchAgentOnlineEvents(dispatch, eventName);
        return false;
      }
    });
}

/**
 * Activity going outwards, normally to Microsoft Directline but this method may redirect to livechat
 */
function outgoingActivity(dispatch, next, action, callbacks) {
  callbacks.hideTextCount();
  callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, undefined);

  // If livechat enabled, route user messages into incoming activities so they get displayed, do not continue this action
  const botSettings = callbacks.getBotSettings();

  if (
    botSettings.inactivePopUpWarning &&
    botSettings.inactivePopUpWarning.enabled === true
  ) {
    clearTimeout(intervalOne);
    intervalOne = setTimeout(() => {
      // Notify bot the user has been inactive
      callbacks.setInactivePopupOne();
    }, parseFloat(botSettings.inactivePopUpWarning.seconds) * 1000);
  }

  if (
    botSettings.inactivePopUpSession &&
    botSettings.inactivePopUpSession.enabled === true
  ) {
    clearTimeout(intervalTwo);
    intervalTwo = setTimeout(() => {
      // Notify bot the user has been inactive
      callbacks.setInactivePopupTwo();
    }, parseFloat(botSettings.inactivePopUpSession.seconds) * 1000);
  }

  if (window.parent) {
    window.parent.postMessage("chatStarted", "*");
  }
  if (action.payload.text === "Human Chat") {
    const liveChatSetings = callbacks.getLiveChatSettings();
    if (liveChatSetings !== undefined && liveChatSetings.provider == "0") {
      const noAgentOnline = setTimeout(() => {
        clearTimeout(noAgentOnline);
        AgentCheck("RequestSent", callbacks, "no_agent_online", dispatch).then(
          (m) => {
            if (m) {
              const AgentOnline = setTimeout(() => {
                clearTimeout(AgentOnline);
                AgentCheck(
                  "RequestReceived",
                  callbacks,
                  "agent_online_not_accepted",
                  dispatch
                ).then((n) => {
                  if (!n) {
                    const AgentOnlineNext = setTimeout(() => {
                      clearTimeout(AgentOnlineNext);
                      AgentCheck(
                        "RequestReceived",
                        callbacks,
                        "agent_online_busy",
                        dispatch
                      );
                    }, 60 * 1000);
                  }
                });
              }, 20 * 1000);
            }
          }
        );
      }, 10 * 1000);
    }
  }

  if (callbacks.isInLivechat() === true) {
    var dl = callbacks.getChatState().directline;
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    // console.log("629");
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );

    callbacks.getChatState().livechat.sendMessage({
      text: action.payload.text,
      customId: String(Math.random()),
    });

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInTwiliochat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    // console.log("655");
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );
    callbacks.getChatState().twiliochat.sendMessage(action.payload.text);

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInZendeskChat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    // console.log("676");
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );
    callbacks.getChatState().zendesk.sendChatMsg(action.payload.text);

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInSignalRchat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    // console.log("699");
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );

    var propertyId = callbacks.getPID();
    if (propertyId === undefined || propertyId === "") {
      var property = localStorage.getItem(
        callbacks.getChatState().lStore.PROPERTYID
      );
      if (property !== undefined && property != null) {
        propertyId = property;
      }
    }
    callbacks
      .getChatState()
      .signalrchat.invoke("SendConversationMessageToAgent", {
        groupname: dl.conversationId,
        message: action.payload.text,
        groupId: callbacks.getGID(),
        propertyId: propertyId,
        agentId: callbacks.getAgentId(),
      });

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInMewsChat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg

    bmbLogMessageBot(action.payload.text, "Visitor", callbacks, activityId);
    //872(callbacks, dl, action.payload.text);
    SendMewsMessage(dispatch, callbacks, dl, action.payload.text);
    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInGenesysPureCloudChat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );
    SendMessageGenesysPureCloud(callbacks, dl, action.payload.text);

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (callbacks.isInAWSConnectChat() === true) {
    var dl = callbacks.getChatState().directline;
    //console.log(dl)
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: callbacks.getChatState().user_id, name: "", role: "user" },
      id: `${activityId}`,
      text: action.payload.text,
      timestamp: new Date().toISOString(),
      type: "message",
    };

    // Log msg
    bmbLogMessageWihMessageId(
      action.payload.text,
      "Visitor",
      callbacks,
      activityId
    );
    SendMessageAmazonConnect(callbacks, dl, action.payload.text);

    return next({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  } else if (action.payload && action.payload.text) {
    let extension = callbacks.getExtension(CHAT_SUGGESTION_EXT_ID);

    if (extension && extension.getSuggestionCallback) {
      let suggestion = extension.getSuggestionCallback(action.payload.text);

      if (suggestion) {
        action.payload.text = suggestion;
        callbacks.setExtension(CHAT_SUGGESTION_EXT_ID, undefined);
      } else {
        return;
      }
    }
  }

  return next(action);
}

function SendChatHistoryMessageGenesysPureCloud(
  token,
  messageIntegrationId,
  textMessage,
  conversationId
) {
  fetch(`${process.env.REACT_APP_API_URL}/genesys/sendmessage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      token: token,
      messageIntegrationId: messageIntegrationId,
      text: textMessage,
      from: {
        id: conversationId,
        idType: "Opaque",
      },
    }),
  }).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}

function SendMessageGenesysPureCloud(callbacks, dl, textMessage) {
  fetch(`${process.env.REACT_APP_API_URL}/genesys/sendmessage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      token: callbacks.genesysPureCloudChatSettings().token,
      messageIntegrationId:
        callbacks.genesysPureCloudChatSettings().messageIntegrationId,
      text: textMessage,
      from: {
        id: dl.conversationId,
        idType: "Opaque",
      },
    }),
  }).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}

function SendMessageAmazonConnect(callbacks, dl, textMessage) {
  fetch(
    `https://participant.connect.${localStorage.getItem(
      callbacks.getChatState().lStore.AWS_CONNECT_REGION
    )}.amazonaws.com/participant/message`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Amz-Bearer":
          callbacks.amazonConnectTokenSettings().ConnectionCredentials
            .ConnectionToken,
      },
      body: JSON.stringify({
        Content: textMessage, // The actual chat message
        ContentType: "text/plain", // Currently, supported type is text/plain
      }),
    }
  ).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}

function SendTypingAmazonConnect(callbacks) {
  fetch(
    `https://participant.connect.${localStorage.getItem(
      callbacks.getChatState().lStore.AWS_CONNECT_REGION
    )}.amazonaws.com/participant/event`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Amz-Bearer":
          callbacks.amazonConnectTokenSettings().ConnectionCredentials
            .ConnectionToken,
      },
      body: JSON.stringify({
        ContentType: "application/vnd.amazonaws.connect.event.typing", // Currently, supported type is text/plain
      }),
    }
  ).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}

function SendMewsMessage(dispatch, callbacks, dl, textMessage) {
  let settings = callbacks.mewsChatSettings();
  let msg = [];
  if (settings !== undefined && settings.Id !== undefined) {
    dispatch({
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "mewschat/message",
        value: {
          message: textMessage,
          threadId: settings.Id,
        },
      },
    });
  }
}

/**
 * Incoming Twilio Chat
 */
function incomingTwiliochat(dispatch, next, action, callbacks) {
  if (action.payload) {
    var msg = action.payload;
    // Send agent chats via store
    if (msg.sid) {
      var dl = callbacks.getChatState().directline;
      if (dl !== undefined && dl.conversationId !== undefined) {
        if (msg.author !== `${dl.conversationId}_user`) {
          const activityId = Math.random();
          var activity = {
            channelId: "directline",
            conversation: { id: dl.conversationId },
            from: { id: "twiliochat", name: "", role: "bot" },
            id: `${activityId}`,
            text: msg.body,
            timestamp: new Date().toISOString(),
            type: "message",
          };
          // Log with bmb API
          bmbLogMessageWihMessageId(msg.body, "Agent", callbacks, activityId);
          return dispatch({
            payload: { activity },
            type: "DIRECT_LINE/INCOMING_ACTIVITY",
          });
        }
      }
    }
  }
}

function incomingAmazonConnectChat(dispatch, next, action, callbacks) {
  if (action.payload) {
    var msg = action.payload;
    // Send agent chats via store

    var dl = callbacks.getChatState().directline;
    if (dl !== undefined && dl.conversationId !== undefined) {
      if (msg.ParticipantRole !== `CUSTOMER`) {
        const activityId = Math.random();
        var activity = {
          channelId: "directline",
          conversation: { id: dl.conversationId },
          from: { id: "connectchat", name: "", role: "bot" },
          id: `${activityId}`,
          text: msg.Content,
          timestamp: new Date().toISOString(),
          type: "message",
        };
        // Log with bmb API
        bmbLogMessageWihMessageId(msg.Content, "Agent", callbacks, activityId);
        return dispatch({
          payload: { activity },
          type: "DIRECT_LINE/INCOMING_ACTIVITY",
        });
      }
    }
  }
}

function incomingAmazonConnectPlainMessage(dispatch, next, action, callbacks) {
  var dl = callbacks.getChatState().directline;
  //console.log(action);
  var msg = action.payload;
  if (dl !== undefined && dl.conversationId !== undefined) {
    const activityId = Math.random();
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: "connectchat", name: "", role: "bot" },
      id: `${activityId}`,
      text: msg,
      timestamp: new Date().toISOString(),
      type: "message",
    };
    // Log with bmb API
    // console.log("996");
    bmbLogMessageWihMessageId(msg, "Agent", callbacks, activityId);
    return dispatch({
      payload: { activity },
      type: "DIRECT_LINE/INCOMING_ACTIVITY",
    });
  }
}

/**
 * Incoming Twilio Chat
 */
function incomingSignalchat(dispatch, next, action, callbacks) {
  if (action.payload) {
    var msg = action.payload;
    // Send agent chats via store
    var dl = callbacks.getChatState().directline;
    if (dl !== undefined && dl.conversationId !== undefined) {
      const activityId = Math.random();
      var activity = {
        channelId: "directline",
        conversation: { id: dl.conversationId },
        from: { id: "signalchat", name: "", role: "bot" },
        id: `${activityId}`,
        text: msg,
        timestamp: new Date().toISOString(),
        type: "message",
      };
      // Log with bmb API
      // console.log("1002");
      bmbLogMessageWihMessageId(msg, "Agent", callbacks, activityId);
      return dispatch({
        payload: { activity },
        type: "DIRECT_LINE/INCOMING_ACTIVITY",
      });
    }
  }
}

function incomingZendeskchat(dispatch, next, action, callbacks) {
  if (action.payload) {
    var msg = action.payload;
    // Send agent chats via store

    var dl = callbacks.getChatState().directline;
    if (dl !== undefined && dl.conversationId !== undefined) {
      //if (msg.author !== `${dl.conversationId}_user`) {
      const activityId = Math.random();
      var activity = {
        channelId: "directline",
        conversation: { id: dl.conversationId },
        from: { id: `${Math.random()}`, name: "", role: "bot" },
        id: `${activityId}`,
        text: msg,
        timestamp: new Date().toISOString(),
        type: "message",
      };
      // Log with bmb API
      // console.log("1030");
      bmbLogMessageWihMessageId(msg, "Agent", callbacks, activityId);
      return dispatch({
        payload: { activity },
        type: "DIRECT_LINE/INCOMING_ACTIVITY",
      });
      //}
    }
  }
  return next(action);
}

/**
 * Incoming Twilio Chat
 */
function TypeTwiliochat(dispatch, next, action, callbacks) {
  if (callbacks.isInTwiliochat() === true) {
    callbacks.sendTwilioTypingIndicator();
  } else if (callbacks.isInZendeskChat() === true) {
    callbacks.sendZendeskTypingIndicator();
  } else if (callbacks.isInSignalRchat() === true) {
    callbacks.sendSignalRTypingIndicator();
  } else if (callbacks.isInAWSConnectChat() === true) {
    SendTypingAmazonConnect(callbacks);
  } else if (callbacks.isInGenesysPureCloudChat() === true) {
    var dl = callbacks.getChatState().directline;
    fetch(`${process.env.REACT_APP_API_URL}/genesys/sendtyping`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: callbacks.genesysPureCloudChatSettings().token,
        messageIntegrationId:
          callbacks.genesysPureCloudChatSettings().messageIntegrationId,
        from: {
          id: dl.conversationId,
          idType: "Opaque",
        },
      }),
    })
      .then((response) => {
        //console.log("typing");
      })
      .catch((err) => {
        console.error("Bmb livechat logging failed :(.");
        console.error(err);
      });
  } else {
    if (action.payload.text.length > 3) {
      const botSettings = callbacks.getBotSettings();
      const chatIntegrationId = callbacks.getIID();
      const chatPropertyId = localStorage.getItem(
        callbacks.getChatState().lStore.PROPERTYID
      );
      var localStorageLanguage = localStorage.getItem(
        callbacks.getChatState().lStore.LANGUAGE
      );
      if (
        (botSettings.features.predictiveSearch &&
          botSettings.features.predictiveSearch === true &&
          localStorageLanguage === "en") ||
        chatIntegrationId === "d5d7f323-6867-472f-a89e-83066b461dfc" ||
        chatIntegrationId === "7a783c53-1a51-48b0-807c-13407f2df25a" ||
        chatIntegrationId === "b1c291a9-83b2-4546-8d9a-914aceaf8581" ||
        chatIntegrationId === "041299de-5b10-44b6-9504-6981ec5180f7" ||
        chatIntegrationId === "e5b12320-148e-43e9-80ca-d23cd2a73684" ||
        chatIntegrationId === "cc525a19-634c-4755-a290-c26e0e391416" ||
        chatIntegrationId === "2ddcb06d-8a79-46dc-ab38-367080ca3f78"
      ) {
        let searchIndexName = "azureblob-index";
        let searchDomain = localStorage.getItem(
          callbacks.getChatState().lStore.DOMAIN
        );

        if (
          chatPropertyId === "2b6acebd-0194-4fe6-b966-b2bf0128a915" ||
          chatPropertyId === "2a043f02-1543-4a6a-8b0a-b3040060d6d8"
        ) {
          searchDomain = "Nuvola";
          searchIndexName = "sabre-index";
        } else if (
          chatPropertyId === "8dc5e990-4033-4e04-97dd-b2bf012c9a5e" ||
          chatPropertyId === "f82ec523-943b-4cd6-a4f0-b3040053912a" ||
          chatPropertyId === "e655dab2-987b-4683-ad9b-599814b414b6"
        ) {
          searchDomain = "Synxis";
          searchIndexName = "sabre-index";
        } else if (
          chatPropertyId === "c170a226-a7fa-440e-adaa-b2bf012cd44f" ||
          chatPropertyId === "2ac8ccc7-de44-4add-b2e6-b3040061235e"
        ) {
          searchDomain = "Vouchers";
          searchIndexName = "sabre-index";
        }

        fetch(`${BMB_AutoComplete_URL}?indexName=${searchIndexName}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            keyword: action.payload.text,
            domain: searchDomain,
          }),
        })
          .then((response) => response.json())
          .then((json) => {
            //console.log(json.data)
            callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, json.data);
          });
      } else {
        callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, undefined);
      }
    } else {
      callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, undefined);
    }
  }
  return next(action);
}

/**
 * Incoming livechat from Livechatinc
 */
function incomingLivechat(dispatch, next, action, callbacks) {
  if (action.payload) {
    var msg = action.payload;

    // Send agent chats via store
    if (!msg.customId) {
      var dl = callbacks.getChatState().directline;
      const activityId = Math.random();
      var activity = {
        channelId: "directline",
        conversation: { id: dl.conversationId },
        from: { id: "livechat", name: "", role: "bot" },
        id: `${activityId}`,
        text: msg.text,
        timestamp: new Date().toISOString(),
        type: "message",
      };

      // Log with bmb API
      // console.log("1139");
      bmbLogMessageWihMessageId(msg.text, "Agent", callbacks, activityId);

      return dispatch({
        payload: { activity },
        type: "DIRECT_LINE/INCOMING_ACTIVITY",
      });
    }
  }
}

/**
 * Incoming typing indicator from livechat
 */
function livechatTyping(dispatch, next, action, callbacks) {
  var dl = callbacks.getChatState().directline;
  var activity = {
    channelId: "directline",
    conversation: { id: dl.conversationId },
    from: { id: "livechat", name: "", role: "bot" },
    id: `${Math.random()}`,
    timestamp: new Date().toISOString(),
    type: "typing",
  };

  return next({ payload: { activity }, type: "DIRECT_LINE/INCOMING_ACTIVITY" });
}

/**
 * Incoming typing indicator from livechat
 */
function twiliochatTyping(dispatch, next, action, callbacks) {
  var dl = callbacks.getChatState().directline;
  var activity = {
    channelId: "directline",
    conversation: { id: dl.conversationId },
    from: { id: "twilio", name: "", role: "bot" },
    id: `${Math.random()}`,
    timestamp: new Date().toISOString(),
    type: "typing",
  };

  return next({ payload: { activity }, type: "DIRECT_LINE/INCOMING_ACTIVITY" });
}

/**
 * Incoming typing indicator from livechat
 */
function signalchatTyping(dispatch, next, action, callbacks) {
  var dl = callbacks.getChatState().directline;
  var activity = {
    channelId: "directline",
    conversation: { id: dl.conversationId },
    from: { id: "signalr", name: "", role: "bot" },
    id: `${Math.random()}`,
    timestamp: new Date().toISOString(),
    type: "typing",
  };

  return next({ payload: { activity }, type: "DIRECT_LINE/INCOMING_ACTIVITY" });
}

/**
 * Livechatinc terminated
 */
function endedLivechat(dispatch, next, action, callbacks) {
  var dl = callbacks.getChatState().directline;
  if (dl !== undefined) {
    var activity = {
      channelId: "directline",
      conversation: { id: dl.conversationId },
      from: { id: "livechat", name: "", role: "bot" },
      id: `${Math.random()}`,
      text: 'The agent has ended the chat. Press "End Chat" above to finish or restart.',
      timestamp: new Date().toISOString(),
      type: "message",
    };
    callbacks.showBookingForm(false, false);
    callbacks.hideTypingTextBox();
  }

  return next({ payload: { activity }, type: "DIRECT_LINE/INCOMING_ACTIVITY" });
}

function dispatchAgentOnlineEvents(dispatch, name) {
  dispatch({
    type: "WEB_CHAT/SEND_EVENT",
    payload: {
      name: name,
      value: {},
    },
  });
}

/**
 * When directline first connects
 */
function onConnect(dispatch, callbacks) {
  callbacks.setExtension(CHAT_AUTOCOMPLETE_EXT_ID, undefined);
  callbacks.setAvailblity(undefined);
  var propertyId = callbacks.getPID();
  var propertyName = "";

  if (propertyId === undefined || propertyId === "") {
    var property = localStorage.getItem(
      callbacks.getChatState().lStore.PROPERTYID
    );
    if (property !== undefined && property != null) {
      propertyId = property;
    }
  }

  var propertyNameStorage = localStorage.getItem(
    callbacks.getChatState().lStore.PROPERTYNAME
  );
  if (propertyNameStorage !== undefined && propertyNameStorage != null) {
    propertyName = propertyNameStorage;
  }

  // console.log(
  //   "callbacks.getChatState().bearerToken",
  //   callbacks.getChatState().bearerToken
  // );
  dispatch({
    type: "WEB_CHAT/SEND_EVENT",
    payload: {
      name: "webchat/join",
      value: {
        language: "en-US",
        gid: callbacks.getGID(),
        iid: callbacks.getIID(),
        pid: propertyId,
        vid: callbacks.getChatState().vid,
        sid: callbacks.getChatState().sid,
        lang: callbacks.getChatState().lang,
        pname: propertyName,
        currencyCode: callbacks.getChatState().currencyCode,
      },
    },
  });

  callbacks.addScrollEvent();
}

/**
 * End the Chat
 */
function disconnectChat(dispatch, next, action, callbacks) {
  localStorage.removeItem(callbacks.getChatState().lStore.CHAT_STATE);
  return next(action);
}

function importStore(callbacks) {
  var stored;
  try {
    stored = localStorage.getItem(callbacks.getChatState().lStore.CHAT_STATE);
    stored = JSON.parse(stored);

    //console.log(stored)
    processStoredActivities(stored);
    if (
      stored !== null &&
      stored !== undefined &&
      stored.activities !== null &&
      stored.activities !== undefined &&
      stored.activities.length > 0
    ) {
      const history = stored.activities.filter((m) => m.type === "message");
      if (history.length > 0) {
        const lastMessage = history[history.length - 1];
        if (lastMessage.suggestedActions) {
          if (lastMessage.inputHint === "Recommender") {
            callbacks.hideTypingTextBox();
          }
        } else {
          if (
            lastMessage.attachments !== undefined &&
            lastMessage.attachments.length > 0 &&
            lastMessage.attachments[0].contentType ===
              "application/vnd.microsoft.card.signin"
          ) {
            callbacks.hideTypingTextBox();
          }
        }
      }
    }
  } catch (e) {
  } finally {
    if (!stored) {
      stored = {};
    }
    if (typeof stored !== "object") {
      stored = {};
    }
  }
  return stored;
}

/**
 * For logging livechat messages with the BMB backend
 */
// function bmbLogMessage(message, source, callbacks) {
//   var propertyId = callbacks.getPID();
//   if (propertyId === undefined || propertyId === "") {
//     var property = localStorage.getItem(
//       callbacks.getChatState().lStore.PROPERTYID
//     );
//     if (property !== undefined && property != null) {
//       propertyId = property;
//     }
//   }
//   var payload = {
//     gid: callbacks.getGID(),
//     iid: callbacks.getIID(),
//     pid: propertyId,
//     vid: callbacks.getChatState().vid,
//     sid: callbacks.getChatState().sid,
//     cid: callbacks.getChatState().directline.conversationId,
//     time: new Date().toISOString(),
//     source: source,
//     message: message,
//     tag: "Human Chat",
//     agentId: callbacks.getAgentId(),
//   };

//   fetch(BMB_LOG_URL, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(payload),
//   }).catch((err) => {
//     console.error("Bmb livechat logging failed :(.");
//     console.error(err);
//   });
// }

function bmbLogMessageWihMessageId(message, source, callbacks, botMessageId) {
  var propertyId = callbacks.getPID();
  if (propertyId === undefined || propertyId === "") {
    var property = localStorage.getItem(
      callbacks.getChatState().lStore.PROPERTYID
    );
    if (property !== undefined && property != null) {
      propertyId = property;
    }
  }
  var payload = {
    gid: callbacks.getGID(),
    iid: callbacks.getIID(),
    pid: propertyId,
    vid: callbacks.getChatState().vid,
    sid: callbacks.getChatState().sid,
    cid: callbacks.getChatState().directline.conversationId,
    time: new Date().toISOString(),
    source: source,
    message: message,
    tag: "Human Chat",
    agentId: callbacks.getAgentId(),
    botMessageId: source !== "Visitor" ? botMessageId : "",
  };

  fetch(BMB_LOG_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}
/**
 * For logging booking messages with the BMB backend
 */
function bmbLogMessageBot(tag, message, source, callbacks, botMessageId) {
  var propertyId = callbacks.getPID();
  if (propertyId === undefined || propertyId === "") {
    var property = localStorage.getItem(
      callbacks.getChatState().lStore.PROPERTYID
    );
    if (property !== undefined && property != null) {
      propertyId = property;
    }
  }
  var payload = {
    gid: callbacks.getGID(),
    iid: callbacks.getIID(),
    pid: propertyId,
    vid: callbacks.getChatState().vid,
    sid: callbacks.getChatState().sid,
    cid: callbacks.getChatState().directline.conversationId,
    time: new Date().toISOString(),
    source: source,
    message: message,
    tag: tag,
    agentId: callbacks.getAgentId(),
    botMessageId: source !== "Visitor" ? botMessageId : "",
  };
  fetch(BMB_LOG_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).catch((err) => {
    console.error("Bmb livechat logging failed :(.");
    console.error(err);
  });
}
/**
 * Sends a stored message history to the given livechat instance
 * @param {*} store React store state
 * @param {*} livechat LivechatSDK instance
 */
export function sendChatStore(storeState, livechat) {
  for (var activity of storeState.activities) {
    var text = "";

    // Build message from activity
    if (activity.type === "message") {
      if (activity.from && activity.from.role) {
        text += activity.from.role + ": ";
      }

      if (activity.text) {
        text += activity.text;
      }

      if (activity.attachments) {
        // console.log("activity.attachments",activity.attachments)
        for (var attachment of activity.attachments) {
          if (
            attachment.contentType === "application/vnd.microsoft.card.hero"
          ) {
            if (attachment.content.title) {
              text += "Card Title: " + attachment.content.title + "\r\n";
            }
            if (attachment.content.text) {
              text += attachment.content.text;
            }
          }
        }
      }

      livechat.sendMessage({
        text: text,
        customId: String(Math.random()),
      });
    }
  }
}

/**
 * Sends a stored message history to the given livechat instance
 * @param {*} store React store state
 * @param {*} livechat LivechatSDK instance
 */
export function sendHistoryToZendesk(storeState, zendesk) {
  for (var activity of storeState.activities) {
    var text = "";

    // Build message from activity
    if (activity.type === "message") {
      if (activity.from && activity.from.role) {
        text += activity.from.role + ": ";
      }

      if (activity.text) {
        text += activity.text;
      }

      if (activity.attachments) {
        for (var attachment of activity.attachments) {
          if (
            attachment.contentType === "application/vnd.microsoft.card.hero"
          ) {
            if (attachment.content.title) {
              text += "Card Title: " + attachment.content.title + "\r\n";
            }
            if (attachment.content.text) {
              text += attachment.content.text + "\r\n";
            }
          }
        }
      }
      zendesk.sendChatMsg(text);
    }
  }
}

/**
 * Sends a stored message history to the given livechat instance
 * @param {*} store React store state
 * @param {*} livechat LivechatSDK instance
 */
export function getChatHistoryForAgent(storeState) {
  var text = "";
  for (var activity of storeState.activities) {
    // Build message from activity
    if (activity.type === "message") {
      if (activity.from && activity.from.role) {
        text += activity.from.role + ": ";
      }

      if (activity.text) {
        text += activity.text + "\r\n";
      }

      if (activity.attachments) {
        for (var attachment of activity.attachments) {
          if (
            attachment.contentType === "application/vnd.microsoft.card.hero"
          ) {
            if (attachment.content.title) {
              text += "Card Title: " + attachment.content.title + "\r\n";
            }
            if (attachment.content.text) {
              text += attachment.content.text + "\r\n";
            }
          }
        }
      }
    }
  }
  return text;
}

/**
 * Sends a stored message history to the given livechat instance
 * @param {*} store React store state
 * @param {*} livechat LivechatSDK instance
 */
export function sendHistoryToGenesysPureCloud(
  conversationId,
  token,
  messageIntegrationId,
  storeState
) {
  var text = "";
  for (var activity of storeState.activities) {
    // Build message from activity
    if (activity.type === "message") {
      if (activity.from && activity.from.role) {
        text += activity.from.role + ": ";
      }

      if (activity.text) {
        text += activity.text + "\r\n";
      }

      if (activity.attachments) {
        for (var attachment of activity.attachments) {
          if (
            attachment.contentType === "application/vnd.microsoft.card.hero"
          ) {
            if (attachment.content.title) {
              text += "Card Title: " + attachment.content.title + "\r\n";
            }
            if (attachment.content.text) {
              text += attachment.content.text + "\r\n";
            }
          }
        }
      }
    }
  }

  SendChatHistoryMessageGenesysPureCloud(
    token,
    messageIntegrationId,
    text,
    conversationId
  );
}

/**
 * Creates the Redux store used by the MS Chat widget
 * Some additional functionality is implemented as middleware, all in this file
 */
let intervalOne;
let intervalTwo;
export default function getChatStore(chatCallbacks, forceNewState) {
  var stored = forceNewState ? {} : importStore(chatCallbacks);

  let store = createStore(stored, ({ dispatch }) => (next) => (action) => {
    if (!action) {
      return next(action);
    }

    if (
      action.type === "DIRECT_LINE/UPDATE_CONNECTION_STATUS" &&
      typeof action.payload?.connectionStatus === "number"
    ) {
      chatCallbacks.setConnectionStatus(action.payload.connectionStatus);
    }

    switch (action.type) {
      case "DIRECT_LINE/CONNECT_FULFILLED":
        onConnect(dispatch, chatCallbacks);
        break;
      case "DIRECT_LINE/INCOMING_ACTIVITY":
        return incomingActivity(dispatch, next, action, chatCallbacks);
      case "WEB_CHAT/SEND_MESSAGE":
        return outgoingActivity(dispatch, next, action, chatCallbacks);
      case "WEB_CHAT/SET_SUGGESTED_ACTIONS":
        return setSuggestedActions(dispatch, next, action, chatCallbacks);
      case "LIVECHAT/NEW_MESSAGE":
        return incomingLivechat(dispatch, next, action, chatCallbacks);
      case "TWILIO/NEW_MESSAGE":
        return incomingTwiliochat(dispatch, next, action, chatCallbacks);
      case "AMAZONCONNECT/NEW_MESSAGE":
        return incomingAmazonConnectChat(dispatch, next, action, chatCallbacks);
      case "AMAZONCONNECT/PLAIN_MESSAGE":
        return incomingAmazonConnectPlainMessage(
          dispatch,
          next,
          action,
          chatCallbacks
        );
      case "SIGNALR/NEW_MESSAGE":
        return incomingSignalchat(dispatch, next, action, chatCallbacks);
      case "ZENDESK/NEW_MESSAGE":
        return incomingZendeskchat(dispatch, next, action, chatCallbacks);
      case "WEB_CHAT/SEND_EVENT":
        return outgoingBackChannelEvents(dispatch, next, action, chatCallbacks);
      case "LIVECHAT/CHAT_END":
        return endedLivechat(dispatch, next, action, chatCallbacks);
      case "LIVECHAT/TYPING":
        return livechatTyping(dispatch, next, action, chatCallbacks);
      case "TWILIO/TYPING":
        return twiliochatTyping(dispatch, next, action, chatCallbacks);
      case "SIGNALR/TYPING":
        return signalchatTyping(dispatch, next, action, chatCallbacks);
      case "DIRECT_LINE/DISCONNECT_FULFILLED":
        return disconnectChat(dispatch, next, action, chatCallbacks);
      case "WEB_CHAT/SET_SEND_BOX":
        return TypeTwiliochat(dispatch, next, action, chatCallbacks);
      default:
        // Nothing to do
        break;
    }
    localStorage.setItem(
      chatCallbacks.getChatState().lStore.CHAT_STATE,
      JSON.stringify(chatCallbacks.getState())
    );
    return next(action);
  });
  return store;
}
